import request from '@/utils/request'

export const getRecognitionRuns = params => request.get('/accounting/contract-recognition-runs', { params })

export const previewRecognition = params => request.get('/accounting/contract-recognition-runs/preview', { params })

export const createRecognitionRun = data => request.post('/accounting/contract-recognition-runs', data, { rawResponse: true })

export const getRecognitionRun = id => request.get(`/accounting/contract-recognition-runs/${id}`)

export const reverseRecognitionRun = id => request.post(`/accounting/contract-recognition-runs/${id}/reverse`)
